const getters = {
  token: (state) => state.user.token,
  userInfo: (state) => state.user.userInfo,
  userHeader: (state) => state.user.userHeader,
  /**
   * @returns true 表示已存在用户信息
   */
  hasUserInfo: (state) => {
    return JSON.stringify(state.user.userInfo) !== '{}'
  },
  hasUserHeader: (state) => {
    return JSON.stringify(state.user.UserHeader) !== '{}'
  }
}
export default getters
